import { ActionTree } from "vuex";
import * as types from "../constants/ins_media_types";
import { GETTER_CURRENT_USER_ID } from "@/store/constants/index_types";
import { UPDATE_EARN_COINS_ACT_USER_INFO } from "../constants/ins_user_info_types";
import Event_bus from "@/utils/event_bus";
import { getFeedById, mediaInfo } from "@/api/ins_api_new/apis/ins_media";

const ins_user_media_list_factory = (mediaList: any) => {
  const usefullMediaList: any = [];
  for (const j of mediaList) {
    usefullMediaList.push({
      comment_count: j.comment_count || 0,
      comments_disabled: j.hasOwnProperty("comments_disabled")
        ? j.comments_disabled
        : !j.comment_likes_enabled,
      id: j.id,
      is_video: j.media_type === 2 ? true : false,
      like_count: j.like_count || 0,
      display_url:
        j.media_type === 8
          ? j.carousel_media[0].image_versions2.candidates[0].url
          : j.image_versions2.candidates[0].url,
      video_type:
        j.media_type === 8
          ? "multi_pic"
          : j.media_type === 2
          ? "movies_pic"
          : "",
      media_type: j.media_type,
      video_view_count: j.view_count || 0,
      shortcode: j.code || null
    });
  }
  return usefullMediaList;
};

const default_ins_user_media = (user_id: string) => {
  return {
    user_id,
    fetch_status: "idle",
    fetched: false,
    more_available: false,
    next_max_id: null,
    ins_media_list: []
  };
};

const actions: ActionTree<any, any> = {
  async [types.FETCH_ONE_USER_INS_MEDIA]({ dispatch }, payload: any) {
    try {
      const { user_id, next_max_id } = payload;
      const ins_media_result: any = await getFeedById(
        user_id,
        next_max_id || ""
      );
      console.log("getFeedById ins_media_result:", ins_media_result);
      return ins_media_result;
    } catch (error) {
      console.log("FETCH_ONE_USER_INS_MEDIA error", error);
      return Promise.reject(error);
    }
  },
  async [types.RERESH_ONE_USER_INS_MEDIA](
    { dispatch, commit, getters },
    payload: any
  ) {
    try {
      const user_id = payload;

      commit(types.UPDATE_INS_USER_MEDIA_STATUS, {
        user_id,
        fetch_status: "fetching"
      });

      // 开始拉取信息:
      const media_data = await dispatch(types.FETCH_ONE_USER_INS_MEDIA, {
        user_id
      });

      // 添加media_list等信息 等同于更新第一页的数据
      const { ins_media_list }: any = await dispatch(
        types.UPDATE_INS_MEDIA_LIST_INFO,
        {
          media_data,
          user_id,
          update_mode: "update"
        }
      );

      commit(types.UPDATE_INS_USER_MEDIA_STATUS, {
        user_id,
        fetch_status: "idle",
        fetched: true
      });

      const current_ins_user_id = getters[GETTER_CURRENT_USER_ID];

      if (user_id === current_ins_user_id) {
        // 拉取的userid的media和当前的user_id相同:
        if (ins_media_list[0]) {
          commit(types.UPDATE_CURRENT_POST_ID, ins_media_list[0].id);
        } else {
          // list为空数组
          commit(types.UPDATE_CURRENT_POST_ID, null);
        }
      }

      // 改变 trigger_act_need_complete_profile
      dispatch(UPDATE_EARN_COINS_ACT_USER_INFO, {
        user_id,
        ins_media_list
      });

      return ins_media_list;
    } catch (error) {
      const user_id = payload;
      commit(types.UPDATE_INS_USER_MEDIA_STATUS, {
        user_id,
        fetch_status: "idle"
      });
      return Promise.reject(error);
    }
  },
  async [types.RERESH_CURRENT_USER_INS_MEDIA]({ dispatch, commit, getters }) {
    try {
      // 下拉刷新用户的media list

      const current_ins_user_id = getters[GETTER_CURRENT_USER_ID];
      if (!current_ins_user_id) {
        return;
      }

      const ins_media_list = await dispatch(
        types.RERESH_ONE_USER_INS_MEDIA,
        current_ins_user_id
      );

      // 判断当前的post id是否在拉取的第一页中，如果不是则改变当前post_id,
      // 还有一种可能就是刷新后发现删除或者增加了post,只是虚拟列表发生了改变
      // const current_post_id = getters[types.GETTER_CURRENT_POST_ID];
      // const find_post = ins_media_list.find((post: any) => {
      //   return post.id === current_post_id;
      // });

      // if (!find_post) {
      //   // 没有找到相同的id：
      //   if (ins_media_list[0]) {
      //     commit(types.UPDATE_CURRENT_POST_ID, ins_media_list[0].id);
      //   } else {
      //     // list为空数组
      //     commit(types.UPDATE_CURRENT_POST_ID, null);
      //   }
      // }

      return ins_media_list;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.REQUEST_CURRENT_INS_USER_MEDIA_MORE]({
    dispatch,
    getters,
    commit
  }) {
    try {
      const current_media_list = getters[types.GETTER_CURRENT_USER_MEDIA_LIST];
      // 没有更多post
      if (current_media_list && current_media_list.more_available === false) {
        return Promise.reject({
          type: "no_more_available"
        });
      }

      // 正在拉取
      if (
        current_media_list &&
        current_media_list.fetch_status === "fetching"
      ) {
        return Promise.reject({
          type: "fetching_more_post"
        });
      }

      // 没有list，或者next_max_id不存在
      if (!current_media_list || !current_media_list.next_max_id) {
        return Promise.reject({
          type: "exception_error",
          message: "Cannot load more post."
        });
      }

      const { next_max_id } = current_media_list;
      const current_ins_user_id = getters[GETTER_CURRENT_USER_ID];

      commit(types.UPDATE_INS_USER_MEDIA_STATUS, {
        user_id: current_ins_user_id,
        fetch_status: "fetching"
      });

      const ins_media_result = await dispatch(types.FETCH_ONE_USER_INS_MEDIA, {
        user_id: current_ins_user_id,
        next_max_id
      });

      const ins_media_info_list = await dispatch(
        types.UPDATE_INS_MEDIA_LIST_INFO,
        {
          media_data: ins_media_result,
          update_mode: "load_more",
          user_id: current_ins_user_id
        }
      );

      // 闲置状态
      commit(types.UPDATE_INS_USER_MEDIA_STATUS, {
        user_id: current_ins_user_id,
        fetch_status: "idle",
        fetched: true
      });

      return ins_media_info_list;
    } catch (error) {
      console.log("REQUEST_CURRENT_INS_USER_MEDIA_MORE errro:", error);
      const current_ins_user_id = getters[GETTER_CURRENT_USER_ID];
      commit(types.UPDATE_INS_USER_MEDIA_STATUS, {
        user_id: current_ins_user_id,
        fetch_status: "idle"
      });
      return Promise.reject(error);
    }
  },
  async [types.UPDATE_INS_MEDIA_LIST_INFO]({ commit, dispatch }, payload: any) {
    try {
      // 添加media_list,more_available,next_max_id等信息
      const { media_data, user_id, update_mode } = payload;
      const insMediaInfoList = {
        ins_media_list: ins_user_media_list_factory(media_data.items),
        more_available: media_data.more_available,
        next_max_id: media_data.next_max_id
      };
      commit(types.UPDATE_INS_MEDIA_LIST_INFO, {
        media_data: insMediaInfoList,
        update_mode,
        user_id
      });
      // 更新列表需要通知post virtual list更新:
      Event_bus.$emit("ins_media_list_change", {
        update_mode,
        user_id,
        media_list: insMediaInfoList.ins_media_list
      });
      return insMediaInfoList;
    } catch (error) {
      console.log("UPDATE_INS_MEDIA_LIST_INFO ero", error);
      return Promise.reject(error);
    }
  },
  async [types.UPDATE_ONE_INS_POST_INFO]({ commit, dispatch }, payload: any) {
    try {
      // 更新某个单个post的media info的信息
      // 只有登录版本的api能够使用
      const { user_id, media_id } = payload;
      const insMediaResult: any = await mediaInfo(media_id, user_id);
      const { status, items } = insMediaResult;
      if (status === "ok") {
        // 修改当前post 信息
        commit(types.UPDATE_ONE_INS_POST_INFO, {
          user_id,
          media_id,
          item: ins_user_media_list_factory(items)[0]
        });
      } else {
        return Promise.reject(insMediaResult);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  [types.CREATE_DEFAULT_INS_USER_MEDIA]({ commit, dispatch }, payload: any) {
    try {
      // 创建一个默认的用户的media信息
      const { user_id } = payload;
      const create_ins_user_media = default_ins_user_media(user_id);
      // mutaion state:
      commit(types.CREATE_DEFAULT_INS_USER_MEDIA, {
        user_id,
        ins_user_media: create_ins_user_media
      });
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.SUPPLEMENT_INS_USER_MEDIA_LIST](
    { commit, dispatch },
    payload: any
  ) {
    try {
      const { user_id } = payload;
      // 创建一个默认的用户的media信息
      dispatch(types.CREATE_DEFAULT_INS_USER_MEDIA, payload);
      // 改变current post id的默认值:
      commit(types.UPDATE_CURRENT_POST_ID, null);
      // change status:fetched，false
      commit(types.UPDATE_INS_USER_MEDIA_STATUS, {
        user_id,
        fetch_status: "fetching",
        fetched: false
      });

      // 开始拉取信息:
      const media_data = await dispatch(types.FETCH_ONE_USER_INS_MEDIA, {
        user_id
      });

      // 添加media_list等信息:
      const { ins_media_list }: any = await dispatch(
        types.UPDATE_INS_MEDIA_LIST_INFO,
        {
          media_data,
          user_id,
          update_mode: "update"
        }
      );

      // 改变拉取状态
      commit(types.UPDATE_INS_USER_MEDIA_STATUS, {
        user_id,
        fetch_status: "idle",
        fetched: true
      });

      // 改变记录下的post id:
      if (ins_media_list[0]) {
        commit(types.UPDATE_CURRENT_POST_ID, ins_media_list[0].id);
      }
    } catch (error) {
      const { user_id } = payload;
      // 失败的fetch_status,用来显示没有拉取过
      commit(types.UPDATE_INS_USER_MEDIA_STATUS, {
        user_id,
        fetch_status: "failed"
      });
      return Promise.reject(error);
    }
  }
};
export default actions;
